import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa"; // Using only one icon, rotating it for both up/down states

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What types of positions are available at Madura Mercerisers?",
      answer:
        "We offer a variety of positions across different departments, including production, quality control, engineering, design, sales, and administration. Please check our current job listings for specific openings.",
    },
    {
      question: "What qualifications do we look for in candidates?",
      answer:
        "We seek candidates with relevant experience and qualifications that align with the job requirements. Additionally, we value skills such as teamwork, problem-solving, and a commitment to sustainability in the fabric and garment industry. ",
    },
    {
      question: "What is the company culture like at Madura Mercerisers?",
      answer:
        "Our company culture is built on teamwork, innovation, and sustainability. We foster an inclusive environment where employees are encouraged to share ideas and contribute to our commitment.",
    },
    ,
    {
      question: "Don’t see a job that fits your skills?",
      answer:
        "If you’re passionate about joining our team but don’t find a current opening that matches your expertise, please send your resume and a cover letter outlining your skills and interests to info@maduramercerisers.com. We’re always looking for great talent!",
    },
    {
      question: "How can I apply for a job at Madura Mercerisers?",
      answer:
        " Interested candidates can apply directly through our website by submitting an online application form for the position they wish to apply for. You can also send your resume and cover letter to our HR team via info@maduramercerisers.com",
    },
    // Add more FAQs as needed
  ];

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div class="flex flex-col md:flex-row w-full p-10">
      <div class="w-full md:w-[40%] bg-white  ">
        <div class="text-4xl font-semibold">Wellness and benefit</div>

        <div class="text-md md:ml-1 mt-4 text-lg">
          As part of our pursuit to lead impactful, fulfilling lives, we take
          benefits pretty seriously.
        </div>
      </div>
      <div class="w-full mt-2 md:mt-0 md:w-[60%] bg-white md:ml-10">
        <div className=" mx-auto  md:pl-4 md:pr-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-300 py-4">
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => toggleAnswer(index)}
              >
                <h3 className="text-lg font-medium">{faq.question}</h3>
                <span
                  className={`text-gray-600 transition-transform duration-500 ease-in-out ${
                    openIndex === index ? "rotate-180" : "rotate-0"
                  }`}
                >
                  <FaChevronDown />
                </span>
              </div>
              <div
                className={`overflow-hidden transition-all duration-700 ease-in-out ${
                  openIndex === index
                    ? "max-h-screen opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <p className="text-gray-700 mt-2">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
